import GoogleLocationPicker from 'shared/components/google_location_picker/components';

export default GoogleLocationPicker;
